import { useMemo } from 'react';
import { useDeepgramDebug } from '../../context/DeepgramDebugContext';

function formatSince(timestamp) {
  if (!timestamp) return '—';
  const diff = Date.now() - timestamp;
  if (diff < 0) return '—';
  if (diff < 1000) return '<1s';
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}m ${remainingSeconds}s`;
}

export default function DeepgramDebugPanel() {
  const { state } = useDeepgramDebug();

  const warning = useMemo(() => {
    if (!state.lastAudioChunkAt) return null;
    if (!state.lastTranscriptAt) return 'Áudio detectado, nenhuma transcrição final recebida.';
    const diff = state.lastAudioChunkAt - state.lastTranscriptAt;
    if (diff > 7000) {
      return `Áudio enviado há ${formatSince(state.lastAudioChunkAt)}, última transcrição há ${formatSince(state.lastTranscriptAt)}.`;
    }
    return null;
  }, [state.lastAudioChunkAt, state.lastTranscriptAt]);

  return (
    <div className="deepgram-debug">
      <div className="deepgram-debug__title">🎧 Deepgram Debug</div>
      <div className="deepgram-debug__grid">
        <span>Status</span>
        <span>{state.status}</span>

        <span>Frames enviados</span>
        <span>{state.framesSent}</span>

        <span>Bytes enviados</span>
        <span>{(state.bytesSent / 1024).toFixed(1)} KB</span>

        <span>Transcrições finais</span>
        <span>{state.transcripts}</span>

        <span>Último áudio</span>
        <span>{formatSince(state.lastAudioChunkAt)}</span>

        <span>Última transcrição</span>
        <span>{formatSince(state.lastTranscriptAt)}</span>
      </div>
      {state.lastEvent && (
        <div className="deepgram-debug__event">
          Último evento: {state.lastEvent}
        </div>
      )}
      {warning && (
        <div className="deepgram-debug__warning">
          {warning}
        </div>
      )}
    </div>
  );
}

